import {Pagination} from 'antd'

export default function App({pages, page, pageChanger}: {pages: any; page: any; pageChanger: any}) {
  return (
    <div className='container d-flex align-items-center justify-content-center'>
      <Pagination defaultCurrent={1} total={pages} current={page} onChange={pageChanger} showSizeChanger={false}/>
    </div>
  )
}
